"use client";

import { useState, useLayoutEffect } from "react";
import debounce from "lodash/debounce"; // Make sure to install lodash if not already present

interface ViewportState {
  isMobile: boolean;
  isLoading: boolean;
}

export const useViewport = (breakpoint: number = 1024) => {
  const [viewportState, setViewportState] = useState<ViewportState>({
    isMobile: false,
    isLoading: true,
  });

  useLayoutEffect(() => {
    // Debounced resize handler
    const handleResize = debounce(() => {
      setViewportState({
        isMobile: window.innerWidth < breakpoint,
        isLoading: false,
      });
    }, 150); // 150ms debounce delay

    // Initial check
    handleResize();

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      handleResize.cancel(); // Cancel any pending debounced calls
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);

  return viewportState;
};
